/* eslint-disable */
import * as Types from './types';

import { ImageFragmentDoc } from './Image';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../../fetcher';
export type AccountSettingsQueryVariables = Types.Exact<{
  locale: Types.Scalars['String'];
}>;


export type AccountSettingsQuery = { __typename?: 'Query', accountSettingsCollection?: { __typename?: 'AccountSettingsCollection', items: Array<{ __typename?: 'AccountSettings', loginSeoTitle?: string | null, loginSeoDescription?: string | null, registerSeoTitle?: string | null, registerSeoDescription?: string | null, registerWellaBrandsUrl?: string | null, registerTermsAndConditionsUrl?: string | null, registerSuccessUrlConsumer?: string | null, registerSuccessUrlProfessionals?: string | null, resetSeoTitle?: string | null, resetSeoDescription?: string | null, activateSeoTitle?: string | null, activateSeoDescription?: string | null, accountOverviewSeoTitle?: string | null, accountOverviewSeoDescription?: string | null, addressesSeoTitle?: string | null, addressesSeoDescription?: string | null, ordersListSeoTitle?: string | null, ordersListSeoDescription?: string | null, orderPageSeoTitle?: string | null, orderPageSeoDescription?: string | null, wishlistSeoTitle?: string | null, wishlistSeoDescription?: string | null, loginImage?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, registerCustomerViewImage?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, registerProfessionalViewImage?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, resetImage?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, activateImage?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, pendingProAccountMsg?: { __typename?: 'AccountSettingsPendingProAccountMsg', json: object } | null } | null> } | null };

export declare const accountSettings: import("graphql").DocumentNode;

export const AccountSettingsDocument = /*#__PURE__*/ `
    query accountSettings($locale: String!) {
  accountSettingsCollection(
    limit: 1
    locale: $locale
    where: {handle: "account-settings"}
  ) {
    items {
      loginSeoTitle
      loginSeoDescription
      loginImage {
        ...ImageFragment
      }
      registerSeoTitle
      registerSeoDescription
      registerCustomerViewImage {
        ...ImageFragment
      }
      registerProfessionalViewImage {
        ...ImageFragment
      }
      registerWellaBrandsUrl
      registerTermsAndConditionsUrl
      registerSuccessUrlConsumer
      registerSuccessUrlProfessionals
      resetSeoTitle
      resetSeoDescription
      resetImage {
        ...ImageFragment
      }
      activateSeoTitle
      activateSeoDescription
      activateImage {
        ...ImageFragment
      }
      accountOverviewSeoTitle
      accountOverviewSeoDescription
      addressesSeoTitle
      addressesSeoDescription
      ordersListSeoTitle
      ordersListSeoDescription
      orderPageSeoTitle
      orderPageSeoDescription
      pendingProAccountMsg {
        json
      }
      wishlistSeoTitle
      wishlistSeoDescription
    }
  }
}
    ${ImageFragmentDoc}`;
export const useAccountSettingsQuery = <
      TData = AccountSettingsQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: AccountSettingsQueryVariables,
      options?: UseQueryOptions<AccountSettingsQuery, TError, TData>
    ) =>
    useQuery<AccountSettingsQuery, TError, TData>(
      ['accountSettings', variables],
      fetcher<AccountSettingsQuery, AccountSettingsQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, AccountSettingsDocument, variables, options),
      options
    );

useAccountSettingsQuery.getKey = (variables: AccountSettingsQueryVariables) => ['accountSettings', variables];
;

useAccountSettingsQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables: AccountSettingsQueryVariables, options?: RequestInit['headers']) => fetcher<AccountSettingsQuery, AccountSettingsQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, AccountSettingsDocument, variables, options);